import React from "react";
import classes from "./Pagination.module.scss";
import { isMobileOnly } from "react-device-detect";
import { FormattedMessage } from "react-intl";

const Pagination = ({
  postPerPage,
  totalData,
  currentPage,
  paginate,
  paginateNext,
  paginatePrev,
  pageStart,
  pageEnd,
  ...props
}) => {
  const pageNumbers = [];
  for (let i = 1; i <= Math.ceil(totalData / postPerPage); i++) {
    pageNumbers.push(i);
  }

  let firstNumber = Math.min(...pageNumbers);
  let lastNumber = Math.max(...pageNumbers);

  let numFirst = pageNumbers[currentPage - 1];
  let numSecond = pageNumbers[currentPage];
  let numLast = pageNumbers[currentPage + 1];

  return (
    <>
      <nav className={classes.Desktop}>
        <ul className={classes.Paginate_wrapper}>
          {currentPage > firstNumber ? (
            <li onClick={() => pageStart(firstNumber)}>
              <div>
                <FormattedMessage
                  id={"global.pagination.first"}
                  defaultMessage={"First Page"}
                />
              </div>
            </li>
          ) : (
            <li className={classes.Li___disabled}>
              <div>
                <FormattedMessage
                  id={"global.pagination.first"}
                  defaultMessage={"First Page"}
                />
              </div>
            </li>
          )}{" "}
          |
          {currentPage > firstNumber ? (
            <li onClick={() => paginatePrev()}>
              <div>
                <FormattedMessage
                  id={"global.pagination.prev"}
                  defaultMessage={"Prev."}
                />
              </div>
            </li>
          ) : (
            <li className={classes.Li___disabled}>
              <div>
                <FormattedMessage
                  id={"global.pagination.prev"}
                  defaultMessage={"Prev."}
                />
              </div>
            </li>
          )}
          {pageNumbers.map((number) => (
            <li
              key={number}
              onClick={() => paginate(number)}
              className={currentPage === number ? classes.Li___active : ""}
            >
              <div
                className={
                  currentPage === number ? classes.Number___active : ""
                }
              >
                {number}
              </div>
            </li>
          ))}
          {currentPage < lastNumber ? (
            <li onClick={() => paginateNext()}>
              <div>
                <FormattedMessage
                  id={"global.pagination.next"}
                  defaultMessage={"Next"}
                />
              </div>
            </li>
          ) : (
            <li className={classes.Li___disabled}>
              <div>
                <FormattedMessage
                  id={"global.pagination.next"}
                  defaultMessage={"Next"}
                />
              </div>
            </li>
          )}{" "}
          |
          {currentPage < lastNumber ? (
            <li onClick={() => pageEnd(lastNumber)}>
              <div>
                <FormattedMessage
                  id={"global.pagination.last"}
                  defaultMessage={"Last Page"}
                />
              </div>
            </li>
          ) : (
            <li className={classes.Li___disabled}>
              <div>
                <FormattedMessage
                  id={"global.pagination.last"}
                  defaultMessage={"Last Page"}
                />
              </div>
            </li>
          )}
          <li className={classes.totalDataInfo}>
            {totalData}{" "}
            {props.label === undefined ? (
              <FormattedMessage
                id={"global.items.title"}
                defaultMessage={"items"}
              />
            ) : (
              props.label
            )}
          </li>
        </ul>
      </nav>

      {isMobileOnly ? (
        <nav className={classes.Mobile}>
          <ul className={classes.Paginate_wrapper_mobile}>
            {currentPage > firstNumber ? (
              <li onClick={() => paginatePrev()}>
                <div>
                  {"<"}{" "}
                  <FormattedMessage
                    id={"global.pagination.prev"}
                    defaultMessage={"< Prev."}
                  />
                </div>
              </li>
            ) : (
              <li className={classes.Li___disabled_mobile}>
                <div>
                  {"<"}{" "}
                  <FormattedMessage
                    id={"global.pagination.prev"}
                    defaultMessage={"< Prev."}
                  />
                </div>
              </li>
            )}
            {/*{pageNumbers.map(number => (*/}
            {/*    <li key={number}*/}
            {/*        onClick={() => paginate(number)}*/}
            {/*        className={ currentPage === number ? classes.Li___active_mobile : ''}>*/}
            {/*        <div className={ currentPage === number ? classes.Number___active_mobile : ''}>{number}</div>*/}
            {/*    </li>*/}
            {/*))}*/}
            {numFirst !== undefined ? (
              <li
                onClick={() => paginate(numFirst)}
                className={
                  currentPage === numFirst ? classes.Li___active_mobile : ""
                }
              >
                <div
                  className={
                    currentPage === numFirst
                      ? classes.Number___active_mobile
                      : classes.Number___normal_mobile
                  }
                >
                  {numFirst}
                </div>
              </li>
            ) : (
              ""
            )}
            {numSecond !== undefined ? (
              <li
                onClick={() => paginate(numSecond)}
                className={
                  currentPage === numSecond ? classes.Li___active_mobile : ""
                }
              >
                <div
                  className={
                    currentPage === numSecond
                      ? classes.Number___active_mobile
                      : classes.Number___normal_mobile
                  }
                >
                  {numSecond}
                </div>
              </li>
            ) : (
              ""
            )}
            {numLast !== undefined ? (
              <li
                onClick={() => paginate(numLast)}
                className={
                  currentPage === numLast ? classes.Li___active_mobile : ""
                }
              >
                <div
                  className={
                    currentPage === numLast
                      ? classes.Number___active_mobile
                      : classes.Number___normal_mobile
                  }
                >
                  {numLast}
                </div>
              </li>
            ) : (
              ""
            )}
            {/*{ currentPage < lastNumber ? <li onClick={() => paginateNext()}><div>{'Next >'}</div></li> : <li className={classes.Li___disabled_mobile}><div>{'Next >'}</div></li> }*/}
            {currentPage < lastNumber ? (
              <li onClick={() => paginateNext()}>
                <div>
                  <FormattedMessage
                    id={"global.pagination.next"}
                    defaultMessage={"Next >"}
                  />{" "}
                </div>
              </li>
            ) : (
              <li className={classes.Li___disabled_mobile}>
                <div>
                  <FormattedMessage id={"global.pagination.next"} />
                </div>
              </li>
            )}
          </ul>
        </nav>
      ) : (
        ""
      )}
    </>
  );
};

export default Pagination;
